(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pk-garment-details"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pk-garment-details')) customElements.define('pk-garment-details',class extends HTMLElement{
 connectedCallback(){
  this.scope=this.closest('.shopify-section'); if(!this.scope)return;
  this.onChange=()=>this.update();this.scope.addEventListener('change',this.onChange);this.update();
 }
 disconnectedCallback(){this.scope?.removeEventListener('change',this.onChange);}
 update(){
  const norm=s=>(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  let cut=this.dataset.initial;
  for(const field of this.scope.querySelectorAll('variant-radios fieldset')){
   if(/^(corte|prenda|tipo de prenda|disponible en)\s*:/.test(norm(field.querySelector('legend')?.textContent).trim()))cut=field.querySelector('input:checked')?.value||cut;
  }
  for(const select of this.scope.querySelectorAll('variant-selects select')){
   if(/corte|prenda|disponible en/.test(norm(select.name)))cut=select.value;
  }
  const value=norm(cut);const key=/poleron|sudadera|hoodie/.test(value)?'poleron':/acid/.test(value)?'acid':/regular|clasic/.test(value)?'regular':'oversize';
  const label={regular:/clasic/.test(value)?'Clásica':'Regular',oversize:'Oversize',poleron:'Polerón',acid:'Acid Wash'}[key];
  this.scope.dataset.pkGarment=key;this.querySelector('[data-garment-label]').textContent=label;
  this.querySelectorAll('[data-garment-profile]').forEach(el=>el.hidden=el.dataset.garmentProfile!==key);
  const original=this.dataset.productTitle;
  const prefix=/^(?:polera(?:\s+(?:oversize|regular(?:\s+fit)?|cl[aá]sica|acid\s+wash))?|poler[oó]n(?:\s+acid\s+wash)?|hoodie)\s+/i;
  if(prefix.test(original)){
   const garment=key==='poleron'?'Polerón':'Polera '+label;
   const nextTitle=original.replace(prefix,garment+' ');
   this.scope.querySelectorAll('h1, .sticky-atc-title-desktop').forEach(title=>{
    if(title.textContent!==nextTitle)title.textContent=nextTitle;
   });
  }
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pk-roa-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pk-roa-size-guide')) { customElements.define('pk-roa-size-guide', class extends HTMLElement { connectedCallback() {
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',()=>this.initialize(),{once:true});
  } else { this.initialize(); }
}
initialize() { if(this.ready || !this.isConnected) return;
 const section=this;
 if(!section.querySelector('[data-size-guide-dialog]')) return;
 this.ready=true;
    const sizeGuideDialog = section.querySelector('[data-size-guide-dialog]');
    const sizeGuideOpenButton = section.querySelector('[data-size-guide-open]');
    const sizeGuideCloseButton = section.querySelector('[data-size-guide-close]');
    const sizeGuideTabButtons = Array.from(section.querySelectorAll('[data-size-guide-tab]'));
    const sizeGuidePanels = Array.from(section.querySelectorAll('[data-size-guide-panel]'));
    const sizeGuideUnitButtons = Array.from(section.querySelectorAll('[data-size-guide-unit]'));
    const sizeGuideValues = Array.from(section.querySelectorAll('[data-size-guide-value]'));
    const sizeGuideCellUnits = Array.from(section.querySelectorAll('[data-size-guide-unit-cell]'));
    const sizeGuideToleranceValues = section.querySelectorAll('[data-size-guide-tolerance-value]');
    const sizeGuideUnitHeadings = section.querySelectorAll('[data-size-guide-unit-heading]');
    const sizeGuideUnitNotes = section.querySelectorAll('[data-size-guide-unit-note]');
    const formatMeasurement = (value, decimals) => value.toFixed(decimals).replace('.', ',');
    const setSizeGuideUnit = (unit) => {
      sizeGuideUnitButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.sizeGuideUnit === unit)));
      sizeGuideValues.forEach((node) => {
        const centimeters = Number.parseFloat((node.dataset.cm || '').replace(',', '.'));
        if (!Number.isFinite(centimeters)) return;
        node.textContent = unit === 'in' ? formatMeasurement(centimeters / 2.54, 1) : formatMeasurement(centimeters, Number.isInteger(centimeters) ? 0 : 1);
      });
      sizeGuideCellUnits.forEach((node) => { node.textContent = unit === 'in' ? 'pulg.' : 'cm'; });
      sizeGuideToleranceValues.forEach(node => {
        const tolerance = Number.parseFloat(node.dataset.tolerance || '0');
        node.textContent = unit === 'in' ? formatMeasurement(tolerance / 2.54, 1) : formatMeasurement(tolerance, Number.isInteger(tolerance) ? 0 : 1);
      });
      sizeGuideUnitHeadings.forEach(node => { node.textContent = unit === 'in' ? 'PULG.' : 'CM'; });
      sizeGuideUnitNotes.forEach(node => { node.textContent = unit === 'in' ? 'pulg.' : 'cm'; });
    };
    const setSizeGuideTab = (tabName, moveFocus = false) => {
      sizeGuideTabButtons.forEach((button) => {
        const selected = button.dataset.sizeGuideTab === tabName;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
        if (selected && moveFocus) button.focus();
      });
      sizeGuidePanels.forEach((panel) => { panel.hidden = panel.dataset.sizeGuidePanel !== tabName; });
    };
    setSizeGuideUnit(sizeGuideDialog?.dataset.defaultUnit === 'in' ? 'in' : 'cm');
    sizeGuideUnitButtons.forEach((button) => button.addEventListener('click', () => setSizeGuideUnit(button.dataset.sizeGuideUnit)));
    setSizeGuideTab('regular');
    sizeGuideTabButtons.forEach((button, index) => {
      button.addEventListener('click', () => setSizeGuideTab(button.dataset.sizeGuideTab));
      button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + sizeGuideTabButtons.length) % sizeGuideTabButtons.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % sizeGuideTabButtons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = sizeGuideTabButtons.length - 1;
        const nextButton = sizeGuideTabButtons[nextIndex];
        if (nextButton) setSizeGuideTab(nextButton.dataset.sizeGuideTab, true);
      });
    });
    sizeGuideOpenButton?.addEventListener('click', () => {
      const profile = section.closest('.shopify-section')?.dataset.pkGarment || 'oversize';
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      const match = sizeGuideTabButtons.find(button => {
        const label = normalize(button.textContent);
        return profile === 'regular' ? /regular|clasic/.test(label) : profile === 'poleron' ? /poleron/.test(label) : profile === 'acid' ? /acid/.test(label) : /oversize/.test(label);
      });
      setSizeGuideTab(match?.dataset.sizeGuideTab || 'regular');
      sizeGuideDialog?.showModal();
      window.requestAnimationFrame(() => (match || sizeGuideTabButtons[0])?.focus());
    });
    sizeGuideCloseButton?.addEventListener('click', () => sizeGuideDialog?.close());
    sizeGuideDialog?.addEventListener('click', (event) => {
      if (event.target === sizeGuideDialog) sizeGuideDialog.close();
    });
    sizeGuideDialog?.addEventListener('close', () => sizeGuideOpenButton?.focus());

} }); }
  } catch(e) { console.error(e); }
})();

})();
